<template>
  <div class="ContactsContent">
    <p class="title phones">ОТДЕЛ БРОНИРОВАНИЯ И РАЗМЕЩЕНИЯ</p>
    <p v-for="(phone, index) in phones" :key="index" class="item phone">
      <a :href="'tel:' + phone.href">{{ phone.label }}</a>
    </p>

    <p class="title address">НАШ АДРЕС</p>
    <p class="item add">357700, Ставропольский край,</p>
    <p class="item add">город-курорт Кисловодск, ул. Линейная, 8</p>

    <p class="title email">E-MAIL</p>
    <p class="item">
      <a href="mailto:info@san-elita.ru">info@san-elita.ru</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ContactsContent',
  data: () => ({
    phones: [
      { label: '+7 (800) 201 27 25', href: '88002012725' },
      { label: '+7 (8793) 35 23 22', href: '78793352322' },
      { label: '+7 (928) 300 22 66', href: '79283002266' },
      { label: '+7 (962) 024 77 81', href: '79620247781' },
    ],
  }),
}
</script>

<style scoped>
.ContactsContent {
  display: grid;
  justify-content: center;
  text-align: center;
  justify-items: center;
}

.ContactsContent > .title {
  font-size: 20px;
  font-weight: lighter;
  padding-bottom: 10px;
  padding-top: 20px;
}

.ContactsContent > .title:first-child {
  padding-top: 0;
}

.ContactsContent > .item {
  margin: 0 0 6px;
  font-size: 16px;
}

.ContactsContent > .item > a {
  color: #39451e;
  font-weight: bold;
  text-decoration: none;
}

.ContactsContent > .item > a:hover {
  color: #c77a00;
}
</style>
